import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const FamilyPostDocProofs = ({translation, docData, setCurrentStep, postSlug, isUpdate}) => {

  const [uploadedEetectricFile, setUploadedEetectricFile] = useState(false);
  const [uploadedCnicFile, setUploadedCnicFile] = useState(false);

  const [oldElectricBill, setOldElectricBill] = useState(null);
  const [oldCnicFile, setOldCnicFile] = useState(null);
  
  useEffect(()=>{
    if (docData){
      setOldCnicFile(docData?.documents?.cnic_front)
      setOldElectricBill(docData?.documents?.electric_bill)
      setUploadedCnicFile(true)
      setUploadedEetectricFile(true)
    }
  }, [docData])
  

  return (
    <>
      <h2 className="mb-6 text-2xl dark:text-white">{translation.other.heading5}</h2>
      <form onSubmit={()=>{setCurrentStep("submit_view_post")}} className="pt-3 pb-6 space-y-4">
        {/* Electric Bill Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="electric_bill" className="block font-semibold mb-2 dark:text-white">
            {translation.other.elect_bill_name}
          </label>

          <FileUploader
            fileNameInDB={'electric_bill'}
            key="electric_file_uploader"
            allowedTypes={['jpeg', 'png', 'pdf', 'bmp', 'jpg', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedEetectricFile(true);
              setOldElectricBill(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.electric_bill_description}
            showPreview={oldElectricBill ? `${process.env.REACT_APP_CDN_URL}/${oldElectricBill}` : null} 
          />
        </div>
        
        {/* CNIC Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="seeker_cnic" className="block font-semibold mb-2 dark:text-white">
            {translation.other.seeker_cnic}
          </label>
          <FileUploader
            fileNameInDB={'cnic_front'}
            key="cnic_file_uploader"
            allowedTypes={['jpeg', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedCnicFile(true);
              setOldCnicFile(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.cnic_front_description}
            showPreview={oldCnicFile ? `${process.env.REACT_APP_CDN_URL}/${oldCnicFile}` : null} 

          />
          
        </div>
        
        
        
        {/* Submit Button */}
        <div className="flex space-x-3">
            {isUpdate &&
              <button
                onClick={()=>{
                  setCurrentStep("attach_video_proofs");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }

            <button
              type="submit"
              className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
              disabled={ !uploadedCnicFile || !uploadedEetectricFile}
            >
              {translation.next}
            </button>
        </div>
      </form>
    </>
  )
}

export default FamilyPostDocProofs;